import useGetReports from 'workflow/common/hooks/useGetReports'
import PerformanceReport from 'workflow/common/performanceReport/PerformanceReport'
import { getEmptyCells } from 'workflow/utils/helpers'

import { ReportSummaryResult } from '../api/api'

type Props = {
  reportSummary: ReportSummaryResult | undefined
  isMachineOpensTicked: boolean
}

const ReportSummary = ({ reportSummary, isMachineOpensTicked }: Props) => {
  const { hasReportsData, reportsCollection, reportsCellCount } = useGetReports(
    {
      reports: reportSummary,
      showMachineOpensTicked: isMachineOpensTicked,
    }
  )

  const reportColumnCount = 2

  const emptyReportsCellCount = reportColumnCount - reportsCellCount

  return (
    <div className="w-1/2 grid grid-cols-2 gap-6 mb-8">
      {hasReportsData && (
        <PerformanceReport reports={reportsCollection}>
          {getEmptyCells(emptyReportsCellCount, 'report')}
        </PerformanceReport>
      )}
    </div>
  )
}

export default ReportSummary
